import { render, staticRenderFns } from "./register.vue?vue&type=template&id=515e3cf8&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=515e3cf8&prod&lang=less&scoped=true&"
import style1 from "./register.vue?vue&type=style&index=1&id=515e3cf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e3cf8",
  null
  
)

export default component.exports